module.exports = __webpack_public_path__ + "img/legal.80cafd38.jpg";